import {
    IRetailMatchJobResult,
    IBrand,
    IRetailMatchJobImage,
    IStoreScoreRecord,
    ISegment,
} from "../Models/Models";
import { IBrandCategory } from "../Models/IBrandCategory";
import { IRetailMatchGeography } from "../Models/IRetailMatchGeography";
import {
    START_RETAIL_MATCH_REPORT,
    SET_RETAIL_MATCH_REPORT_MODAL_VISIBLE,
    SET_LOADING_RETAIL_MATCH_REPORT,
    SET_LOADING_UPDATE_RETAIL_MATCH_JOB,
    SET_LOADING_BRANDS,
    SET_LOADING_BRAND,
    SET_LOADING_CATEGORIES,
    SET_LOADING_RETAIL_MATCH_GEOGRAPHIES,
    GET_RETAIL_MATCH_RESULTS_SUCCESS,
    SET_RETAIL_MATCH_BENCHMARK_RECORD,
    GET_RETAIL_MATCH_BRANDS_SUCCESS,
    GET_RETAIL_MATCH_CATEGORIES_SUCCESS,
    GET_RETAIL_MATCH_GEOGRAPHIES_SUCCESS,
    SUBMIT_RETAIL_MATCH_REPORT_SUCCESS,
    UPDATE_RETAIL_MATCH_JOB_SUCCESS,
    ADD_RETAIL_MATCH_IMAGE_SUCCESS,
    GET_RETAIL_MATCH_BRAND_SUCCESS,
    GET_RETAIL_MATCH_RESULTS_FAILURE,
    GET_RETAIL_MATCH_BRAND_FAILURE,
    GET_RETAIL_MATCH_BRANDS_FAILURE,
    GET_RETAIL_MATCH_CATEGORIES_FAILURE,
    GET_RETAIL_MATCH_GEOGRAPHIES_FAILURE,
    SUBMIT_RETAIL_MATCH_REPORT_FAILURE,
    CLEAR_RETAIL_MATCH_RESULTS,
    SET_LOADING_MOSAIC_SEGMENTS,
    GET_MOSAIC_SEGMENTS_SUCCESS,
    SET_LOADING_BRANDS_SAMPLE_SET_DATA,
    GET_BRANDS_SAMPLE_SET_DATA_SUCCESS,
    UPDATE_BRAND_LOGO_SUCCESS,
    SET_SELECTED_BRAND,
    SET_RETAIL_MATCH_MODAL_MARKER_CLUSTERER,
    UPDATE_RETAIL_MATCH_SITE_DETAILS_SUCCESS,
} from "../Actions/Types";
import { IBrandSampleSet } from "../Models/IBrandSampleSet";

export interface IRetailMatchState {
  brands: IBrand[];
  categories: IBrandCategory[];
  geographies: IRetailMatchGeography[];
  jobResult: IRetailMatchJobResult;
  benchmarkRecord: IStoreScoreRecord;
  loadingReport: boolean;
  loadingUpdateJob: boolean;
  loadingBrand: boolean;
  loadingBrands: boolean;
  loadingCategories: boolean;
  retailMatchSubmitReportModalVisible: boolean;
  loadingGeographies: boolean;
  mosaicSegments: ISegment[];
  loadingMosaicSegments: boolean;
  loadingSampleSetData: boolean;
  brandSampleSetData: IBrandSampleSet[];
  selectedBrand: IBrand;
  modalMarkerClusterer: MarkerClusterer;
}

const defaultState: IRetailMatchState = {
    brands: [],
    categories: [],
    geographies: [],
    jobResult: null,
    benchmarkRecord: null,
    loadingReport: false,
    loadingUpdateJob: false,
    loadingBrand: false,
    loadingBrands: false,
    loadingCategories: false,
    retailMatchSubmitReportModalVisible: false,
    loadingGeographies: false,
    mosaicSegments: [],
    loadingMosaicSegments: false,
    loadingSampleSetData: false,
    brandSampleSetData: [],
    selectedBrand: null,
    modalMarkerClusterer: null,
};

export const matchReportOutput = (
    state: IRetailMatchState = { ...defaultState },
    action
): IRetailMatchState => {
    switch (action.type) {
    /** misc */
        case SET_LOADING_BRANDS_SAMPLE_SET_DATA: {
            return {
                ...state,
                loadingSampleSetData: action.data as boolean,
            };
        }
        case SET_LOADING_MOSAIC_SEGMENTS: {
            return {
                ...state,
                loadingMosaicSegments: action.data as boolean,
            };
        }
        case START_RETAIL_MATCH_REPORT: {
            return {
                ...state,
                retailMatchSubmitReportModalVisible: true,
            };
        }
        case SET_RETAIL_MATCH_REPORT_MODAL_VISIBLE: {
            return {
                ...state,
                retailMatchSubmitReportModalVisible: action.data as boolean,
            };
        }
        case SET_LOADING_RETAIL_MATCH_REPORT: {
            return {
                ...state,
                loadingReport: action.data as boolean,
            };
        }
        case SET_LOADING_UPDATE_RETAIL_MATCH_JOB: {
            return {
                ...state,
                loadingUpdateJob: action.data as boolean,
            };
        }
        case SET_LOADING_BRANDS: {
            return {
                ...state,
                loadingBrands: action.data as boolean,
            };
        }
        case SET_LOADING_BRAND: {
            return {
                ...state,
                loadingBrand: action.data as boolean,
            };
        }
        case SET_LOADING_CATEGORIES: {
            return {
                ...state,
                loadingCategories: action.data as boolean,
            };
        }
        case SET_LOADING_RETAIL_MATCH_GEOGRAPHIES: {
            return {
                ...state,
                loadingGeographies: action.data as boolean,
            };
        }
        /** success */
        case GET_BRANDS_SAMPLE_SET_DATA_SUCCESS: {
            return {
                ...state,
                brandSampleSetData: action.data as IBrandSampleSet[],
            };
        }
        case GET_MOSAIC_SEGMENTS_SUCCESS: {
            return {
                ...state,
                mosaicSegments: action.data as ISegment[],
            };
        }
        case GET_RETAIL_MATCH_RESULTS_SUCCESS: {
            return {
                ...state,
                jobResult: action.data as IRetailMatchJobResult,
            };
        }

        case SET_RETAIL_MATCH_BENCHMARK_RECORD: {
            return {
                ...state,
                benchmarkRecord: action.data as IStoreScoreRecord,
            };
        }

        case GET_RETAIL_MATCH_BRANDS_SUCCESS: {
            return {
                ...state,
                brands: action.data as IBrand[],
            };
        }
        case GET_RETAIL_MATCH_CATEGORIES_SUCCESS: {
            return {
                ...state,
                categories: action.data as IBrandCategory[],
            };
        }
        case GET_RETAIL_MATCH_GEOGRAPHIES_SUCCESS: {
            return {
                ...state,
                geographies: action.data as IRetailMatchGeography[],
            };
        }
        case SUBMIT_RETAIL_MATCH_REPORT_SUCCESS: {
            return {
                ...state,
            };
        }
        case UPDATE_RETAIL_MATCH_JOB_SUCCESS: {
            return {
                ...state,
                jobResult: {
                    ...state.jobResult,
                    job: {
                        ...state.jobResult.job,
                        siteDetails: action.data.siteDetails,
                    },
                },
            };
        }

        case ADD_RETAIL_MATCH_IMAGE_SUCCESS: {
            return {
                ...state,
                jobResult: {
                    ...state.jobResult,
                    job: {
                        ...state.jobResult.job,
                        images: [
                            ...state.jobResult.job.images,
              action.data as IRetailMatchJobImage,
                        ],
                    },
                },
            };
        }

        case UPDATE_BRAND_LOGO_SUCCESS: {
            const brandsCopy = [...state.jobResult.job.brands];
            for (const brand of brandsCopy) {
                if (brand.brandId === action.data.brandId) {
                    brand.logoPath = action.data.logoUrl;
                    break;
                }
            }

            return {
                ...state,
                jobResult: {
                    ...state.jobResult,
                    job: {
                        ...state.jobResult.job,
                        brands: brandsCopy,
                    },
                },
            };
        }

        case GET_RETAIL_MATCH_BRAND_SUCCESS: {
            const incomingBrand: IBrand = action.data as IBrand;
            /** copy the data, and remove the "old" brand data */
            const brandsCopy: IBrand[] = [...state.brands].filter((b: IBrand) => {
                return b.brandId !== incomingBrand.brandId;
            });
            /** add the brand back in with the "new" data */
            brandsCopy.push(incomingBrand);
            return {
                ...state,
                brands: brandsCopy,
            };
        }
        /** failure */
        case GET_RETAIL_MATCH_RESULTS_FAILURE: {
            return {
                ...state,
            };
        }
        case GET_RETAIL_MATCH_BRAND_FAILURE: {
            return {
                ...state,
            };
        }
        case GET_RETAIL_MATCH_BRANDS_FAILURE: {
            return {
                ...state,
            };
        }
        case GET_RETAIL_MATCH_CATEGORIES_FAILURE: {
            return {
                ...state,
            };
        }
        case GET_RETAIL_MATCH_GEOGRAPHIES_FAILURE: {
            return {
                ...state,
            };
        }
        case SUBMIT_RETAIL_MATCH_REPORT_FAILURE: {
            return {
                ...state,
            };
        }
        case CLEAR_RETAIL_MATCH_RESULTS:
            return {
                ...state,
                jobResult: null,
                benchmarkRecord: null,
            };

        case SET_SELECTED_BRAND: {
            return {
                ...state,
                selectedBrand: action.data as IBrand,
            };
        }

        case SET_RETAIL_MATCH_MODAL_MARKER_CLUSTERER: {
            return {
                ...state,
                modalMarkerClusterer: action.data as MarkerClusterer,
            };
        }
        case UPDATE_RETAIL_MATCH_SITE_DETAILS_SUCCESS: {
            return {
                ...state,
                jobResult: {
                    ...state.jobResult,
                    job: {
                        ...state.jobResult.job,
                        siteDetails: action.data,
                    },
                },
            };
        }
        default:
            return state;
    }
};
